import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {fabric} from 'fabric';
import firebase from 'firebase/app';
import 'firebase/database';

/** @class BoothArrangement
  * A component for placing booths in a hall
  * @prop {string} dataURL - the url of the hall
  * @prop {Array} boothList - the list of booths to arrange
  * @prop {integer} width - the width of the area to display booths
  * @prop {integer} height - the height of the area to display booths
  */
export default class BoothArrangement extends Component {
  /** @constructor
    * Constructs a new instance of BoothArrangement
    */
  constructor(props) {
    super(props);
    this.processBooths = this.processBooths.bind(this);
  }
  /** @method componentDidMount
    * Loads the fabric library and sets up event
    * handling for moving and scaling booths.
    */
  componentDidMount() {
    this.canvas = new fabric.Canvas('c', {
      width: this.props.width,
      height: this.props.height,
      preserveObjectStacking: true,
    });
    this.processBooths(this.props.boothList);
    this.canvas.on('object:modified', (obj) => {
      var updates = {
        [`${this.props.dataURL}/${obj.target.tag}/x`]: parseInt(obj.target.left, 10),
        [`${this.props.dataURL}/${obj.target.tag}/y`]: parseInt(obj.target.top, 10),
        [`${this.props.dataURL}/${obj.target.tag}/width`]: obj.target.width * obj.target.scaleX,
        [`${this.props.dataURL}/${obj.target.tag}/height`]: obj.target.height * obj.target.scaleY
      }
      firebase.database().ref().update(updates);
    });
    window.canvas = this.canvas;
  }
  /** @method componentWillReceiveProps
    * Responds to changes in the boothList.
    */
  componentWillReceiveProps(newProps) {
    this.processBooths(newProps.boothList);
  }
  /** @method processBooths
    * Regenerates the booths on the fabric canvas
    * to reflect any changes.
    */
  processBooths(booths) {
    // Remove prior instances of booths
    this.canvas.remove.apply(this.canvas, this.canvas.getObjects().concat());
    // Process new booths
    booths.forEach((booth) => {
      fabric.Image.fromURL(booth.image, (image) => {
        image.set({
          tag: booth.id,
          left: booth.x || 0,
          top: booth.y || 0,
          hasRotatingPoint: false,
          lockRotation: true,
          opacity: booth.published ? 1 : 0.7
        });
        // Check for booth width/height; if not present,
        // set them to image size:
        if(!booth.width || !booth.height) {
          var updates = {
            [`${this.props.dataURL}/${booth.id}/width`]: image.width,
            [`${this.props.dataURL}/${booth.id}/height`]: image.height
          }
          firebase.database().ref().update(updates);
        }
        image.scaleToWidth(booth.width || image.width);
        image.scaleToHeight(booth.height || image.height)
        this.canvas.add(image);
        this.canvas.renderAll();
      });
    });
  }
  /** @method render
    * Renders the component
    */
  render() {
    return (
      <canvas
        id="c"
        width={this.props.width}
        height={this.props.height}
        ref={node => {this.refs = node;}} />
    );
  }
}


BoothArrangement.propTypes = {
  dataURL: PropTypes.string.isRequired,
  boothList: PropTypes.array.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired
}



// WEBPACK FOOTER //
// ./src/hall-editor/booth-arrangement.js